import React, { Component, Fragment } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import '../../css/react-css-transitions.scss';
import withArticleTracking from '../common/withArticleTracking';
import { PinterestShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import { segmentTrackEvent } from '../../utils';
import { SITE_HOST } from '../../consts';

export class LinkCopierContainer extends Component {
  constructor() {
    super();
    this.state = {
      copied: false,
      utmTracker: '?utm_source=link_copy&utm_medium=referral',
    };
    this.handleCopy = this.handleCopy.bind(this);
  }

  handleCopy() {
    this.setState({
      copied: true,
    });
  }

  componentDidUpdate() {
    if (this.state.copied) {
      setTimeout(() => {
        this.setState({
          copied: false,
        });
      }, 3000);
    }
  }

  render() {
    const { copied, utmTracker } = this.state;
    const { module, category, heroImage, tags, hedUrl, social, seo, isCerosMobile = false, isSponsored } = this.props;

    const shareUrl = `${SITE_HOST}/${category}/${hedUrl}`;
    // const shareUrl = `https://vip-qa.purewow.net/${category}/${hedUrl}`;
    // ^ for local env ^

    const TrackedCopyToClipboard = withArticleTracking(CopyToClipboard);

    return (
      <Fragment>
      { (!isCerosMobile || (isCerosMobile && !isSponsored)) &&
        <TrackedCopyToClipboard
          text={typeof window !== 'undefined' ? window.location.href + utmTracker : ''}
          wrapperClassName="link-copier-container"
          onCopy={this.handleCopy}
          dataEventName="article_shared"
          actionType="clipboard"
          moduleName={module}
          component="link_copier">
          <div className="link-copier">
            <span className={`icon-copy-link-black link-copier-icon copy-link-icon copied-${copied} ${module}`} />
          </div>
        </TrackedCopyToClipboard>}

        {module === 'header_scrolling' 
        ? <Fragment> 
            <PinterestShareButton
              className="pinterest-circle"
              beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'pin_sticknav'})}
              url={shareUrl}
              description={seo.metaDescription}
              alt={social.pinterestImageAlt || 'pinterest share image'}
              media={social.pinterestImage || heroImage.imageSrcMobile ||  'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
            </PinterestShareButton> 
            <FacebookShareButton
                className="facebook-circle"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'fb_sticknav'})}
                url={shareUrl}
                alt={social.facebookImageAlt || 'facebook share image'}>
            </FacebookShareButton>
            <TwitterShareButton
                className="twitter-circle"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'twitter_sticknav'})}
                url={shareUrl}
                title={seo.titleTag}
                alt={social.facebookImageAlt || 'facebook share image'}>
            </TwitterShareButton>
          </Fragment>
        : <></>}

      </Fragment>
    );
  }
}


export default LinkCopierContainer;
